import { LocationFilter, SiteManagementLocationFragment } from '@occc/graphql';
import { PaginationHandler, PaginationInfo } from '@occc-app/hooks/usePaginatedQuery';

import { AdditionalMenuOption } from '../types';

export interface LocationListContainerProps {
  filter: LocationFilter;
  isBulkSelected: (name: string) => boolean;
  bulkSelectedItems: string[];
  handleBulkSelectAllClick: (items: string[]) => void;
  handleBulkSelect: (uuid: string) => void;
  getAdditionalRowMenuOptions?: (
    location: SiteManagementLocationFragment,
  ) => AdditionalMenuOption[];
  loading?: boolean;
  paginationInfo?: PaginationInfo;
  onPageChange?: PaginationHandler;
  isUserPermittedToEdit: boolean;
  renderEmpty?: () => JSX.Element;
}

export enum Location_Status {
  All = 'ALL',
  Active = 'ACTIVE',
  Deleted = 'DELETED',
}

export type LocationFilterFormValues = {
  status: Location_Status;
  siteId: string;
  address: string;
};

export type StatusType = Location_Status | undefined;
